import { Card, LinkButton } from '@beautyburst/ui';
import { semanticColor, space, typeStyle } from '@beautyburst/tokens';
import { customerHref } from '../base-path.ts';

/** A real customer-facing 404, rather than a blank route or a feature teaser. */
export function NotFoundScreen() {
  return (
    <section aria-labelledby="not-found-title">
      <Card>
        <h1
          id="not-found-title"
          style={{ ...typeStyle('headingLg'), color: semanticColor.textPrimary, margin: 0 }}
        >
          Page not found
        </h1>
        <p
          style={{
            ...typeStyle('body'),
            color: semanticColor.textSecondary,
            margin: `${space[2]} 0 ${space[4]}`,
          }}
        >
          The page you requested is not available.
        </p>
        <LinkButton href={customerHref('/')}>Go to homepage</LinkButton>
      </Card>
    </section>
  );
}
